import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import SydLabel from '../../../../../../../../commonDesign/SydLabel'

function JsonTextarea ({ label, helperText, value, onChange, rows = 4, fontSize = '0.8125rem' }) {
  const [text, setText] = useState(() => value ? JSON.stringify(value, null, 2) : '')
  const [error, setError] = useState(null)

  useEffect(() => {
    setText(value ? JSON.stringify(value, null, 2) : '')
    setError(null)
  }, [value])

  const handleBlur = useCallback(() => {
    const trimmed = text.trim()
    if (!trimmed) {
      setError(null)
      onChange(null)
      return
    }
    try {
      const parsed = JSON.parse(trimmed)
      setError(null)
      onChange(parsed)
    } catch (e) {
      setError('Invalid JSON')
    }
  }, [text, onChange])

  const labelContent = (
    <>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onBlur={handleBlur}
        rows={rows}
        style={{
          width: '100%',
          fontFamily: 'var(--font-mono, monospace)',
          fontSize,
          padding: '8px',
          border: error ? '1px solid var(--color-danger-500)' : 'var(--border-neutral-thin)',
          borderRadius: 'var(--border-radius-sm)',
          backgroundColor: 'var(--theme-color-surface-d0)',
          resize: 'vertical',
          outline: 'none'
        }}
        placeholder='{ }'
      />
      {error && (
        <div style={{ color: 'var(--color-danger-500)', fontSize: '0.75rem', marginTop: '4px' }}>
          {error}
        </div>
      )}
    </>
  )

  if (label) {
    return (
      <SydLabel label={label} helperText={helperText}>
        {labelContent}
      </SydLabel>
    )
  }

  return labelContent
}

JsonTextarea.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  rows: PropTypes.number,
  fontSize: PropTypes.string
}

export default JsonTextarea
